// extracted by mini-css-extract-plugin
export default {"boatoffers":"Home_boatoffers__UE7gL","deals":"Home_deals__AT97Z","brandpromise":"Home_brandpromise__7IVAm","boatofferssmall":"Home_boatofferssmall__y+ZUM"};